
import classes from "./ButtonSend.module.scss"
import { IconButton } from "@educaplay/core/components";
import { Button, COLORS, NAME_SOUND_HOVER, useGameSounds, useMediaQuery, useTranslate } from "@educaplay/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Dialog } from "@educaplay/core/components";
import clsx from "clsx";
import { isUnansweredAnswer } from "@educaplay/store/utils/functions";
import { QUESTION_TYPE, VIDEOQUIZ_SOUNDS } from "../../utils/constants";
import { finishGame } from "@educaplay/store/slices/gameSlice";
import FinishIcon from "../../icons/Finish";
import { SCREENS } from "@educaplay/store/constants";

export default function ButtonSend(props) {

    const { className, type = "submit", passFinalQuestion } = props;
    const gameSound = useGameSounds();
    const questions = useSelector(state => state.game.questions);
    const dispatch = useDispatch();
    const isMobileTablet = (useMediaQuery("(min-width: 1280px)"));
    const view = useSelector(state => state.game.view);
    const t = useTranslate();
    const [hasAnswered, setHasAnswered] = useState(false);
    const interactuableQuestions = questions.filter(question => question.questionType !== QUESTION_TYPE.Info);
    const numUnansweredQuestions = interactuableQuestions.length - interactuableQuestions.filter(question => !isUnansweredAnswer(question.answer)).length;
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    const sendExamFunction = () => {
        if (view !== SCREENS.GAME) return;
        setHasAnswered(true);
        const finishParams = questions.every((question) => question.questionType === QUESTION_TYPE.Info) ? { points: 100 } : null;
        dispatch(finishGame(finishParams))
        closeDialog();
    }

    const sendExamHandler = () => {
        if (hasAnswered) return;
        gameSound.play(VIDEOQUIZ_SOUNDS.SUBMIT);
        if (numUnansweredQuestions > 0) {
            gameSound.play(VIDEOQUIZ_SOUNDS.MOVE);
            setOpenConfirmationDialog(true);
        } else {
            sendExamFunction();
        }
    }

    useEffect(() => {
        if (numUnansweredQuestions > 0) return;
        gameSound.play(VIDEOQUIZ_SOUNDS.SUBMIT);
    }, [numUnansweredQuestions, gameSound])

    const closeDialog = () => {
        setOpenConfirmationDialog(false);
    }

    useEffect(() => {
        if (!passFinalQuestion) return;
        gameSound.play(VIDEOQUIZ_SOUNDS.MOVE);
    }, [passFinalQuestion, gameSound])

    return (
        <>
            <Dialog open={openConfirmationDialog} onClose={closeDialog} variant="explanation" animated>
                <div className={classes.feedbackContainer}>
                    <div className={classes.feedbackHeader}>{t('specific.questionsLeft', { unanswereds: numUnansweredQuestions })}</div>
                    <div className={classes.feedbackMsgContainer}>
                        <div className={classes.feedbackMsg}>
                            {t('specific.finishTest')}
                        </div>
                        <div className={classes.buttonsFeedbackContainer}>
                            <Button onClick={closeDialog} className={classes.btnCancel} onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)} >{t('common.settings.cancel')}</Button>
                            <Button onClick={sendExamFunction} className={classes.btnAccept} onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}>{t('common.settings.accept')}</Button>
                        </div>
                    </div>
                </div>

            </Dialog>

            <div className={clsx(classes.buttonContainer, className)}>
                {!isMobileTablet ?
                    <IconButton
                        type={type}
                        icon={<FinishIcon color={COLORS.primaryDark2} />}
                        className={clsx(numUnansweredQuestions > 0 && classes.incompleteaspect, classes.sendButton)}
                        onClick={sendExamHandler}
                        disabled={!passFinalQuestion}
                        onMouseEnter={() => {
                            gameSound.play(NAME_SOUND_HOVER);
                        }} />
                    :
                    <Button type={"button"}
                        icon={<FinishIcon color={COLORS.primaryDark2} />}
                        className={clsx(classes.sendButtonDesktop, numUnansweredQuestions > 0 && classes.incompleteaspect)}
                        disabled={!passFinalQuestion}
                        onClick={sendExamHandler}
                        onMouseEnter={() => {
                            gameSound.play(NAME_SOUND_HOVER);
                        }}
                    >
                        {t('specific.finish')}
                    </Button>}
            </div>




        </>
    );
}